module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "toc"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "lang"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0005#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0006#ch01"
    }
  }, [_vm._v("Classic Bigfoot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0006#ah0101"
    }
  }, [_vm._v("Face-to-Face with a Whistling Bigfoot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0006#ah0102"
    }
  }, [_vm._v("Pennsylvania Bigfoot Society Investigates Dubois")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0006#ah0103"
    }
  }, [_vm._v("The Montgomery County Gorilla Case")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0006#ah0104"
    }
  }, [_vm._v("The Creature of Muddy Creek")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0006#ah0105"
    }
  }, [_vm._v("Bigfoot Stalks York County")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0006#ah0106"
    }
  }, [_vm._v("Incident at Lutherlyn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0006#ah0107"
    }
  }, [_vm._v("In the Woods")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0006#ah0108"
    }
  }, [_vm._v("Mystery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0006#ah0109"
    }
  }, [_vm._v("Whitey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0006#ah0110"
    }
  }, [_vm._v("Gorilla on the Loose")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0006#ah0111"
    }
  }, [_vm._v("Incident at East Pennsboro")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0006#ah0112"
    }
  }, [_vm._v("Heart Attack")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0006#ah0113"
    }
  }, [_vm._v("Encounters on Chestnut Ridge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0006#ah0114"
    }
  }, [_vm._v("The Jacobs Photos")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0006#ah0115"
    }
  }, [_vm._v("Sam Sherry’s Encounter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0006#ah0116"
    }
  }, [_vm._v("The Deer Killer Case")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0006#ah0117"
    }
  }, [_vm._v("The Murderous Monster of Brier Hill")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0006#ah0118"
    }
  }, [_vm._v("The Strange Thing that Happened to Joe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0006#ah0119"
    }
  }, [_vm._v("The Strange Wild Man")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0007#ch02"
    }
  }, [_vm._v("Bizarre Bigfoot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0007#ah0201"
    }
  }, [_vm._v("Bigfoot and the Mysterious Sphere")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0007#ah0202"
    }
  }, [_vm._v("Beauty and the Bigfoot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0007#ah0203"
    }
  }, [_vm._v("The Goose-stealing Bigfoot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0007#ah0204"
    }
  }, [_vm._v("Beech Hill Bigfoot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0007#ah0205"
    }
  }, [_vm._v("Bigfoot Lands in a UFO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0007#ah0206"
    }
  }, [_vm._v("The Apple Barrel Raider")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0007#ah0207"
    }
  }, [_vm._v("Red Eyes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0007#ah0208"
    }
  }, [_vm._v("The Disappearing Bigfoot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0008#ch03"
    }
  }, [_vm._v("Other Strange Humanoid Creatures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0008#ah0301"
    }
  }, [_vm._v("The Ridge Road Monster")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0008#ah0302"
    }
  }, [_vm._v("Encounter with an Albatwitch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0008#ah0303"
    }
  }, [_vm._v("Attack of the Strange Fanged Creature")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0008#ah0304"
    }
  }, [_vm._v("The Yellow What-Is-It")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0008#ah0305"
    }
  }, [_vm._v("Tommyknockers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0009#ch04"
    }
  }, [_vm._v("Big Cats")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0009#ah0401"
    }
  }, [_vm._v("A Cat Named Bertha")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0009#ah0402"
    }
  }, [_vm._v("The Camping Trip")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0009#ah0403"
    }
  }, [_vm._v("Backpackers See Strange Cat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0009#ah0404"
    }
  }, [_vm._v("The Mountain Lion of Welsh Mountain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0009#ah0405"
    }
  }, [_vm._v("Big Cat Killed in Palo Alto")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0009#ah0406"
    }
  }, [_vm._v("Mountain Lion in Wilkes-Barre")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0009#ah0407"
    }
  }, [_vm._v("The Black Cat in the Schoolyard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0010#ch05"
    }
  }, [_vm._v("Serpents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0010#ah0501"
    }
  }, [_vm._v("The Broad Top Snake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0010#ah0502"
    }
  }, [_vm._v("Lizard in a Drain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0010#ah0503"
    }
  }, [_vm._v("Lake Erie’s Sea Monster")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0010#ah0504"
    }
  }, [_vm._v("Ogua")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0010#ah0505"
    }
  }, [_vm._v("The Death of Maggie May")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0011#ch06"
    }
  }, [_vm._v("Creatures of the Air")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0011#ah0601"
    }
  }, [_vm._v("The Jersey Devil")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0011#ah0602"
    }
  }, [_vm._v("A Cemetery Flyover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0011#ah0603"
    }
  }, [_vm._v("Carried Off by a Thunderbird?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0011#ah0604"
    }
  }, [_vm._v("Close Encounters of the Bird Kind")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0011#ah0605"
    }
  }, [_vm._v("The Capture of a Thunderbird")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0011#ah0606"
    }
  }, [_vm._v("Attack of the Thunderbird")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0011#ah0607"
    }
  }, [_vm._v("Incident at Cross Fork Creek")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0012#ch07"
    }
  }, [_vm._v("Werewolves")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0012#ah0701"
    }
  }, [_vm._v("Protected by a Werewolf")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0012#ah0702"
    }
  }, [_vm._v("The Bloodsucking Beast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0012#ah0703"
    }
  }, [_vm._v("Whispers from Western Pennsylvania")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0012#ah0704"
    }
  }, [_vm._v("A Werewolf at College")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0012#ah0705"
    }
  }, [_vm._v("Red Dog Fox")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0012#ah0706"
    }
  }, [_vm._v("The Dog-Man of Westmoreland County")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0013#refs"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spbmonsterspennsylvania0014#acknow"
    }
  }, [_vm._v("Acknowledgments")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01180e61","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/spb-monsterspennsylvania0004.vue
// module id = 63
// module chunks = 0